import { render, staticRenderFns } from "./94.vue?vue&type=template&id=552f2898&scoped=true&"
var script = {}
import style0 from "./94.vue?vue&type=style&index=0&id=552f2898&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552f2898",
  null
  
)

export default component.exports